<template>
  <div class="home">
    <NavigationBar />
    <HomePage />
    <AboutPage />
    <MethodologyPage />
    <FooterBar />
  </div>
</template>

<script>
import HomePage from "@/components/HomePage.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import AboutPage from "@/components/AboutPage.vue";
import MethodologyPage from "@/components/MethodologyPage.vue";
import FooterBar from "@/components/FooterBar.vue";

// Import CSS Files
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/font-awesome.css";
import "../assets/css/styles.css";

// Local Bootstrap Files
import "../assets/css/bootstrap.min.css";

// Import JS Files
import "bootstrap";
import "../assets/js/main";

export default {
  name: "HomeView",
  components: {
    HomePage,
    NavigationBar,
    AboutPage,
    MethodologyPage,
    FooterBar,
  },
};
window.addEventListener("scroll", function () {
  var header = document.querySelector(".home header .container .row .main-nav");
  header.classList.toggle("navSticky", scrollY > 500);
});

// console.log(menumobil);
</script>
